import { UploadAssetFieldMui } from '@app/modules/assets/screens/upload/components/UploadAssetFieldMui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

export function InstagramQuickExportSettings({ fieldPrefix }: { fieldPrefix?: string }) {
  const { $t } = useIntl();
  return (
    <Box>
      <UploadAssetFieldMui
        name={`${fieldPrefix || ''}.config.coverUrl`.replace(/^\./, '')}
        inputProps={{
          label: $t({
            id: 'common.loadThumbnail',
            defaultMessage: 'Cargar thumbnail',
          }),
          size: 'sm',
          accept: 'image/*',
          maxSizeMb: 8,
          displayMode: 'chip',
        }}
      />
    </Box>
  );
}
